import { render, staticRenderFns } from "./AutoSelectParent.vue?vue&type=template&id=fb39b676"
import script from "./AutoSelectParent.vue?vue&type=script&lang=js"
export * from "./AutoSelectParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports